import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { HeatmapPlot } from "../components/HeatmapPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.heat_tool_name()}
        toolPath="/heatmap"
      />
      <SciHeader title={m.heat_h1()} intro={m.heat_intro()} />

      <HeatmapPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.heat_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.heat_ex1(), m.heat_ex2(), m.heat_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.heat_faq_q1(), a: m.heat_faq_a1() },
          { q: m.heat_faq_q2(), a: m.heat_faq_a2() },
          { q: m.heat_faq_q3(), a: m.heat_faq_a3() },
          { q: m.heat_faq_q4(), a: m.heat_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
